var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
//-- External Frameworks --------------------------------------------------------------------------
// React
import React from "react";
import { Navbar, Nav, NavItem } from "react-bootstrap";
// Redux
import * as Redux from "redux";
import { connect } from "react-redux";
// Router
import { Link } from "react-router";
import * as appRouting from "appRouting";
// user
import * as Actions from "user/authentication/actions";
import * as ApplicationActions from "app/application/actions";
import TransitionWarning from "common/ui/components/transitionWarning/TransitionWarning";
//-- Styles -------------------------------------------------------------------------------------------------------------------------------
import styles from "./AppTopNav.less";
function mapStateToProps(state) {
    let props = {
        user: state.user,
        application: state.app
    };
    return props;
}
function mapDispatchToProps(dispatch) {
    return {
        applicationActions: Redux.bindActionCreators(ApplicationActions, dispatch),
        dispatch: dispatch
    };
}
//-- Component -------------------------------------------------------------------------------------------------------------------------------
let AppTopNav = class AppTopNav extends React.Component {
    constructor(props) {
        super(props);
        this.handleChatButtonClick = this.handleChatButtonClick.bind(this);
    }
    handleChatButtonClick() {
        if (typeof window !== "undefined") {
            const zohoChatElement = document.querySelector("div.zsiq_floatmain.zsiq_theme1.siq_bR");
            if (zohoChatElement) {
                zohoChatElement.click();
            }
        }
    }
    handleLogout(e) {
        e.preventDefault();
        Actions.logout()(this.props.dispatch);
    }
    resetBlockers() {
        const { user, application, applicationActions } = this.props;
        const app = application;
        if (user && user.userInfo && user.loggedIn) {
            if (!app.isAuthenticatedToView) {
                applicationActions.createAction_PageAuthentication(true);
            }
            if (!app.isAuthorisedToView) {
                applicationActions.createAction_PageAuthorisation(true);
            }
            if (app.isErrorView) {
                applicationActions.createAction_PageError(false);
            }
        }
    }
    render() {
        const { user, dispatch } = this.props;
        return (React.createElement(Navbar, { fluid: true, inverse: true, className: `${styles.navbar} ${user.loggedIn ? styles.authenticated : styles.unauthenticated}` },
            React.createElement(Navbar.Header, null,
                React.createElement(Navbar.Brand, null,
                    React.createElement(Link, { className: styles.logoLink, onClick: () => this.resetBlockers(), to: "/" },
                        React.createElement("span", { className: styles.logo })))),
            React.createElement(Nav, { pullRight: true },
                React.createElement(NavItem, { onClick: () => this.handleChatButtonClick() },
                    React.createElement("span", { className: styles.menuButton },
                        React.createElement("span", { className: "fa fa-comment" }),
                        " Live Chat")),
                !user.loggedIn &&
                    React.createElement(NavItem, { onClick: () => appRouting.loginNavigate(dispatch) },
                        React.createElement("span", { className: styles.menuButton }, "Sign In")),
                user.loggedIn &&
                    React.createElement(NavItem, { onClick: (e) => this.handleLogout(e) },
                        React.createElement("span", { className: styles.menuButton }, "Sign Out"))),
            user.loggedIn && React.createElement(TransitionWarning, { authenticated: true })));
    }
};
AppTopNav = __decorate([
    connect(mapStateToProps, mapDispatchToProps)
], AppTopNav);
export { AppTopNav };
export default AppTopNav;
//{user.userInfo && user.userInfo.firstName}
